import styled from 'styled-components';

export const OptionListStyles = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 0 16px;
`;

export const OptionStyles = styled.div<{
  isSelected: boolean;
}>`
  cursor: pointer;
  width: 100%;
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(20px);
  padding: 14px;
  display: flex;
  flex-direction: column;
  gap: 4px;
  align-items: center;
  justify-content: center;
  position: relative;
  height: 76px;
  border: ${({ isSelected }) => (isSelected ? '2px solid #803EFF' : 'none')};

  ${({ isSelected }) => isSelected && 'background: #2D1A55'}
`;

export const OptionIconStyles = styled.div<{
  position: 'left' | 'right';
  isSelected: boolean;
}>`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: ${({ position }) => (position === 'left' ? '16px' : 'unset')};
  right: ${({ position }) => (position === 'right' ? '16px' : 'unset')};
  font-size: 0;
  line-height: 0;
  color: ${({ isSelected }) => (isSelected ? '#803EFF' : '#533b51')};

  img {
    width: 76px;
    height: 76px;
  }
`;
